import { API } from "../../App";

export default function AdminOrdersTab({ 
  ordersData, 
  adminKey, 
  onRefresh 
}) {
  const updateOrderStatus = async (orderId, newStatus, currentTracking) => {
    let tracking = currentTracking;
    if (newStatus === "shipped" && !tracking) {
      tracking = prompt("Enter tracking number (optional):");
    }
    await fetch(`${API}/admin/orders/${orderId}?admin_key=${adminKey}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status: newStatus, tracking_number: tracking })
    });
    onRefresh();
  };

  return (
    <div>
      {/* Order Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl p-4 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66]">Total Orders</p>
          <p className="text-2xl font-light text-[#2D2A26]">{ordersData?.stats?.total_orders || 0}</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66]">Pending Shipment</p>
          <p className="text-2xl font-light text-yellow-600">{ordersData?.stats?.pending_shipment || 0}</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66]">Shipped</p>
          <p className="text-2xl font-light text-blue-600">{ordersData?.stats?.shipped || 0}</p>
        </div>
        <div className="bg-white rounded-xl p-4 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66]">Completed</p>
          <p className="text-2xl font-light text-green-600">{ordersData?.stats?.completed || 0}</p>
        </div>
      </div>

      {/* Orders List */}
      <div className="space-y-4">
        {ordersData?.orders?.map(order => (
          <div key={order.order_id} className="bg-white rounded-xl border border-[#E8E4DE] overflow-hidden">
            <div className="p-4 border-b border-[#E8E4DE] flex flex-wrap justify-between items-center gap-4">
              <div>
                <p className="font-medium text-[#2D2A26]">#{order.order_id}</p>
                <p className="text-sm text-[#6E6A66]">{order.user_email}</p>
              </div>
              <div className="text-right">
                <p className="font-medium text-[#A87C6D]">${order.total?.toFixed(2)}</p>
                <p className="text-sm text-[#6E6A66]">{new Date(order.created_at).toLocaleDateString()}</p>
              </div>
            </div>
            <div className="p-4">
              <div className="mb-4">
                {order.items?.map((item, idx) => (
                  <div key={idx} className="flex justify-between text-sm py-1">
                    <span>{item.name} x{item.quantity}</span>
                    <span className="text-[#6E6A66]">${(item.unit_price * item.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>
              {order.shipping_address && (
                <div className="text-sm text-[#6E6A66] mb-4">
                  <p className="font-medium">Ship to:</p>
                  <p>{order.shipping_address.name}, {order.shipping_address.street}, {order.shipping_address.city}, {order.shipping_address.state} {order.shipping_address.zip_code}</p>
                </div>
              )}
              <div className="flex items-center justify-between gap-4">
                <select
                  value={order.status}
                  onChange={(e) => updateOrderStatus(order.order_id, e.target.value, order.tracking_number)}
                  className="px-3 py-2 border border-[#E8E4DE] rounded-lg text-sm"
                >
                  <option value="paid">Paid</option>
                  <option value="shipped">Shipped</option>
                  <option value="delivered">Delivered</option>
                  <option value="completed">Completed</option>
                </select>
                {order.tracking_number && (
                  <span className="text-sm text-[#6E6A66]">Tracking: {order.tracking_number}</span>
                )}
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  order.status === "paid" ? "bg-yellow-100 text-yellow-700" :
                  order.status === "shipped" ? "bg-blue-100 text-blue-700" :
                  "bg-green-100 text-green-700"
                }`}>
                  {order.status}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {(!ordersData?.orders || ordersData.orders.length === 0) && (
        <div className="text-center py-12 text-[#6E6A66]">
          No orders yet.
        </div>
      )}
    </div>
  );
}
